import React, { useEffect, useState, useMemo } from "react"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap"
import axios from "axios"
import { toast, ToastContainer } from "react-toastify"
import Spinners from "components/Common/Spinner"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentAcadid } from "store/Common/Actions"
import { getSubjectListStart } from "store/SubjectRequest/action"
import moment from "moment"

const SubjectWise = () => {
  const dispatch = useDispatch()
  const { subjectList } = useSelector(state => state.SubjectRequest)
  const { acadID, division } = useSelector(state => state.CommonReducer)
  const token = JSON.parse(localStorage.getItem("Token"))

  const [loading, setLoading] = useState(false)
  const [div_id, setDiv_id] = useState("")
  const [divName, setDivName] = useState()
  const [subName, setSubName] = useState()
  const [subject_id, setSubject_id] = useState("")
  const [studentList, setStudentList] = useState([])
    const [EventWiseInfo, setSetEventWiseInfo] = useState()
  
  const [date, setDate] = useState()
  const [academic, setAcademic] = useState([])
  const [acad_id, setAcad_id] = useState("")
  const [remark, setRemark] = useState({})
  let baseUrl = "https://marcopolo.prisms.in/api/examfillmarks"

  const getAcademicYear = async () => {
    try {
      await axios({
        method: "GET",
        url: `${baseUrl}/get-Academic-year`,
        headers: {
          Authorization: token,
        },
      }).then(res => {
        setAcademic(res.data.data)
      })
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (localStorage.getItem("sid")) {
      dispatch(
        getCurrentAcadid({
          sid: localStorage.getItem("sid"),
        })
      )
    }
    const currentMonth = new Date().toISOString().slice(0, 7)

    setDate(currentMonth)
    getAcademicYear()
  }, [])

  useEffect(() => {
    if (div_id) {
      dispatch(
        getSubjectListStart({
          acadId: acad_id || acadID.acadid,
          classDivId: div_id,
        })
      )
    }
  }, [div_id])

  useEffect(() => {
    const getStudentList = async () => {
      setLoading(true)
      try {
        const response = await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/notification/get-student_list",
          data: {
            acad_id: acad_id || acadID.acadid,
            classdiv_id: div_id,
          },
          headers: {
            Authorization: token,
          },
        })
        setStudentList(response.data.data)
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    const getEventMonthRecord = async () => {
      try {
        await axios({
          method: "POST",
          url: `https://marcopolo.prisms.in/api/teacher-anecdotal/get-mothwise-fill-records`,
          data: {
            acad_id: acad_id || acadID.acadid,
            division_id: div_id,
            subject_id: subject_id,
            month: date,
          },
          headers: {
            Authorization: token,
          },
        }).then(res => {
          console.log(res.data)
          setSetEventWiseInfo(res.data.data)
        })
      } catch (error) {
        console.log(error)
      }
    }

    if ((acad_id || acadID.acadid) && div_id && subject_id && date) {
      getStudentList()
    }
    if ((acad_id || acadID.acadid) && div_id && subject_id && date) {
      getEventMonthRecord()
    }
  }, [acadID.acadid, div_id, acad_id, subject_id, date])

  const handleSubmit = async studid => {
    try {
      if (!date) {
        toast.warning("Select month")
      }
      const [year, month] = date.split("-")
      const formattedMonth =
        new Date(`${year}-${month}-01`).toLocaleString("en-US", {
          month: "long",
        }) + `-${year}`

      const data = {
        acad_id: acad_id || acadID.acadid,
        stud_id: studid,
        division_id: div_id,
        subId_Rem: {
          [String(subject_id)]: remark,
        },
        month: formattedMonth,
      }
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/teacher-anecdotal/month-subject-wise",
        data: data,
        headers: {
          Authorization: token,
        },
      })
        .then(res => {
          console.log(res.data)
          toast.success(res.data.data)
        })
        .catch(error => {
          console.log(error)
        })
    } catch (error) {
      console.error("Error in handleSubmit:", error)
    }
  }

  const handleRemarkChange = (userId, value) => {
    setRemark(prev => ({
      ...prev,
      [userId]: value,
    }))
  }
  return (
    <div className="">
      <Container>
        <Card className="shadow-lg rounded-lg p-0">
          <CardBody className="p-2">
            <Row>
              <Col xl="12" md="12" sm="12">
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={e => setAcad_id(e.target.value)}
                >
                  <option value={acadID.acadid}>{acadID.academics}</option>
                  {academic &&
                    academic
                      .filter(year => year.acadid !== acadID.acadid)
                      .map(year => (
                        <option key={year.acadid} value={year.acadid}>
                          {year.academics}
                        </option>
                      ))}
                </select>
              </Col>
              <Col xl="4" className="mt-3">
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={e => {
                    const selectedItem = JSON.parse(e.target.value)
                    setDiv_id(selectedItem.id)
                    setDivName(selectedItem.div_name)
                  }}
                >
                  <option>Select Division</option>
                  {division.length > 0 &&
                    division.map((item, index) => (
                      <option
                        key={item.id}
                        value={JSON.stringify({
                          id: item.id,
                          div_name: item.div_name,
                        })}
                      >
                        {item.div_name}
                      </option>
                    ))}
                </select>
              </Col>

              <Col xl="4" className="mt-3">
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={e => {
                    const selectedItem = JSON.parse(e.target.value)
                    setSubject_id(String(selectedItem.id))
                    setSubName(selectedItem.subject)
                  }}
                >
                  <option value="">Select Subject</option>
                  {subjectList &&
                    subjectList.length > 0 &&
                    subjectList.map((item, index) => (
                      <option
                        key={item.id}
                        value={JSON.stringify({
                          id: item.id,
                          subject: item.subject,
                        })}
                      >
                        {item.subject}
                      </option>
                    ))}
                </select>
              </Col>

              <Col xl="12" md="12" sm="12" className="mt-3">
                <Input
                  type="month"
                  value={date}
                  onChange={e => setDate(e.target.value)}
                />
              </Col>
            </Row>

            {loading ? (
              <Spinners />
            ) : (
              <Table className="mt-3" bordered striped responsive>
                <thead className="mt-3 table-info">
                  <tr>
                    <th>Student Name</th>
                    <th>{subName}</th>
                  </tr>
                </thead>
                <tbody>
                  {studentList &&
                    studentList.map((item, idx) => {
                      const studentRemark =
                      remark[item.user_id] ??
                      (Array.isArray(EventWiseInfo)
                        ? EventWiseInfo.find(report => report.user_id === item.user_id)?.remark
                        : "") ??
                      "";
                      return (
                        <tr key={idx}>
                          <td>{item.student_name}</td>
                          <td>
                            <Input
                              type="textarea"
                              className="form-control"
                              placeholder=""
                              value={studentRemark}
                              onChange={e =>
                                handleRemarkChange(item.user_id, e.target.value)
                              }                            />
                            <Button
                              className="btn btn-success mt-2"
                              onClick={e => handleSubmit(item.user_id)}
                            >
                              submit
                            </Button>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Container>
      <ToastContainer />
    </div>
  )
}

export default SubjectWise
